var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 35,
    fill: "#F26526"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 33.26c0-8.295 8.07-15 18-15s18 6.645 18 14.925c0 8.28-8.07 15-18 15a21.28 21.28 0 0 1-3.66-.315c-1.02.204-5.475 1.792-9.754 3.317l-1.301.463a1.499 1.499 0 0 1-2.001-1.563 1.5 1.5 0 0 1 .411-.882c2.175-2.07 3.3-3.945 3.3-5.595A13.605 13.605 0 0 1 17 33.26Zm12.893-.094a2.267 2.267 0 1 1-4.533 0 2.267 2.267 0 0 1 4.533 0Zm7.509 0a2.267 2.267 0 1 1-4.534 0 2.267 2.267 0 0 1 4.534 0Zm4.887 2.267a2.267 2.267 0 1 0 0-4.534 2.267 2.267 0 0 0 0 4.534Z",
    fill: "#fff"
  })));
};

export default SvgChat;